// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'marianne', 'marianne Fallback', arial"},"className":"__className_a32572"};